// This file is AUTOGENERATED, do not edit it manually!!!

export const menu = {
    access_levels: 'Níveis de acesso',
    activityList: 'Centro de atividades',
    addlicenses: 'Adicionar licenças',
    approvals: 'Pedidos de aprovação',
    archive: 'Arquivo',
    billingReport: 'Relatório de cobrança',
    builder: 'Construtor',
    commonReports: 'Relatórios comuns',
    companySettings: 'Configurações da empresa',
    customers: 'Clientes',
    customfields: 'Campos personalizados',
    dashboard: 'Painel de controle',
    days_left: '1#O teste expira em {0} dia#O teste expira em {0} dias',
    featurelabs: 'Laboratórios de recursos',
    forms: 'Formulários personalizados',
    generalOptions: 'Configurações da conta',
    guestPortal: 'Portal do visitante',
    integrations: 'Automações',
    jobroles: 'Funções de trabalho',
    logout: 'Sair',
    mobile_apps: 'Aplicativos móveis',
    myassignments: 'Minhas atribuições',
    myoptions: 'Minhas configurações',
    mySettingsNotifications: 'Notificações',
    mySettingsOptions: 'Configurações avançadas',
    mySettingsProfile: 'Perfil',
    myvacations: 'Minhas férias',
    notificationCenter: 'Centro de notificações',
    notifications: 'Configurações de notificação',
    payrollReport: 'Relatório de folha de pagamento',
    portfolios: 'Portfólios',
    powerbi: 'Dashboard de BI',
    presetsHideViewTooltip: 'Ocultar visualização',
    presetsListTitle: 'Visualizações salvas',
    projectCentricView: 'Visão centrada no projeto',
    ratecards: 'Tabelas de tarifas',
    recommend_us: 'Programa de indicação',
    reportgenerator: 'Relatório personalizado',
    reports: 'Relatórios',
    resourcesPage: 'Recursos',
    roles: 'Funções',
    search: 'Buscar',
    sharedProjectPlans: 'Planos de projeto compartilhados',
    space: 'Configurações de espaço',
    spaces: 'Espaços',
    summaryReport: 'Relatório de resumo de registros de tempo',
    support_center: 'Centro de suporte',
    support_chat: 'Chat de suporte',
    systemLists: 'Listas do sistema',
    timelogs: 'Registros de tempo',
    updateLicense: 'Atualizar licença',
    upgrade_now: 'Atualize agora',
    users: 'Usuários',
    vacationsreport: 'Férias',
    whatif: 'Simulação de carga de recursos',
    workflows: 'Fluxos de trabalho',
};
